import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    subTitle:
      'We want your money to be safe. Important actions like adding a mandate require your passcode.',
    title: 'Confirm with your passcode',
  },
  fr: {
    subTitle:
      'La sécurité de votre argent est notre priorité. Les démarches importantes comme l’ajout d’un nouveau mandat nécessitent votre code secret',
    title: 'Confirmez avec votre code secret',
  },
});

export default locales;
